export default {
    Super: 1,
    Admin: 2,
    Regular: 3,
    Coach: 4
};